module.exports = __webpack_public_path__ + "static/media/results_svg.1e98157b.svg";